@for (timer of sortedTimers; track trackByTimerName($index, timer)) {
  <nx-timer
    [timer]="timer"
    [readonly]="readonly"
  ></nx-timer>
}
